// ============================================================================
// XENOVIA PRIME (XVPR) — CENTRAL CONFIGURATION
// ----------------------------------------------------------------------------
// Edit presale values, links and static content here. Placeholders marked
// [CONFIGURE] indicate values that must be supplied before going live.
// No backend, database or wallet integration is used — everything is static.
// ============================================================================

export const PRESALE_CONFIG = {
  status: "PRESALE NOW OPEN",
  // Presale start date/time (ISO). Countdown targets this value.
  presaleStart: "2026-11-01T00:00:00Z",
  currentPhase: "[CONFIGURE]",
  presalePrice: "[CONFIGURE]",
  tokensAvailable: "[CONFIGURE]",
  tokensSold: "[CONFIGURE]",
  // progress: a number 0–100 to fill the bar, or null to show [CONFIGURE]
  progress: null,
  nextPhasePrice: "[CONFIGURE]",
  presaleEnd: "[CONFIGURE]",
  presaleLink: "[CONFIGURE PRESALE LINK]",
};

export const DOC_CONFIG = {
  whitepaperUrl:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_xvpr-presale/artifacts/tger2ccp_XVPR%20Whitepaper%20Version%201.0.pdf",
  whitepaperPdfUrl:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_xvpr-presale/artifacts/tger2ccp_XVPR%20Whitepaper%20Version%201.0.pdf",
};

// Optional social links — leave empty; links only render when a real URL exists.
export const SOCIAL_LINKS = {
  // twitter: "",
  // telegram: "",
  // discord: "",
  // github: "",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Presale", href: "#presale" },
  { label: "Tokenomics", href: "#tokenomics" },
  { label: "Utility", href: "#utility" },
  { label: "Ecosystem", href: "#ecosystem" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "FAQ", href: "#faq" },
];

export const HERO_HIGHLIGHTS = [
  { value: "50 TRILLION", label: "Fixed Supply" },
  { value: "BEP-20", label: "Token Standard" },
  { value: "BNB CHAIN", label: "Smart Chain" },
  { value: "NO MINTING", label: "Future Minting" },
];

export const PRINCIPLES = [
  {
    n: "01",
    title: "Predictable Supply",
    body: "No future minting. Supply is designed to remain permanently fixed.",
  },
  {
    n: "02",
    title: "Economic Sustainability",
    body: "The ecosystem is designed around growth rather than perpetual token inflation.",
  },
  {
    n: "03",
    title: "Open Participation",
    body: "Designed to support broad participation across the community.",
  },
  {
    n: "04",
    title: "Security First",
    body: "Security takes precedence over rapid feature deployment.",
  },
  {
    n: "05",
    title: "Community Governance",
    body: "The protocol is designed to progressively transition toward community governance and DAO participation.",
  },
];

export const WHY_XVPR = [
  { title: "Excessive Speculation", body: "The project is designed around utility rather than speculation alone." },
  { title: "Inflationary Token Models", body: "XVPR uses a fixed-supply model." },
  { title: "High Transaction Costs", body: "XVPR is deployed on BNB Smart Chain." },
  { title: "Limited Governance", body: "The project is designed to progressively transition toward decentralized governance." },
  { title: "Fragmented User Experience", body: "The long-term vision includes an integrated ecosystem around XVPR." },
];

export const SPECS = [
  { label: "Name", value: "Xenovia Prime" },
  { label: "Symbol", value: "XVPR" },
  { label: "Blockchain", value: "BNB Smart Chain" },
  { label: "Standard", value: "BEP-20" },
  { label: "Decimals", value: "18" },
  { label: "Maximum Supply", value: "50,000,000,000,000 XVPR" },
  { label: "Inflation", value: "None" },
  { label: "Minting", value: "Permanently Disabled" },
  { label: "Burning", value: "Community-approved buyback & burn" },
  { label: "Governance", value: "DAO — Future Phase" },
];

export const TOKENOMICS = [
  { name: "Community & Public Distribution", pct: 40, amount: "20,000,000,000,000 XVPR", color: "#4F46E5" },
  { name: "Liquidity & Exchange Support", pct: 20, amount: "10,000,000,000,000 XVPR", color: "#6366F1" },
  { name: "Ecosystem Development", pct: 15, amount: "7,500,000,000,000 XVPR", color: "#8B5CF6" },
  { name: "Staking Rewards", pct: 10, amount: "5,000,000,000,000 XVPR", color: "#A78BFA" },
  { name: "Foundation Treasury", pct: 10, amount: "5,000,000,000,000 XVPR", color: "#C4B5FD" },
  { name: "Team & Advisors", pct: 5, amount: "2,500,000,000,000 XVPR", color: "#E0E7FF" },
];

export const VESTING = [
  { title: "Team & Advisors", body: "12-month initial lock • Linear over 36 months" },
  { title: "Foundation Treasury", body: "6-month initial lock • Governance-controlled" },
  { title: "Ecosystem Development", body: "3-month initial lock • Milestone-based" },
  { title: "Community Allocation", body: "No initial lock • Public distribution schedule" },
  { title: "Liquidity", body: "Immediate • Controlled deployment" },
  { title: "Staking Rewards", body: "No initial lock • Distributed according to staking protocol" },
];

export const UTILITY = [
  { title: "Network Payments", body: "Designed as a medium of exchange within the Xenovia Prime network.", tag: "PLANNED" },
  { title: "Merchant Payments", body: "Planned tooling for businesses to accept XVPR for goods and services.", tag: "PLANNED" },
  { title: "Staking", body: "A planned staking framework to reward long-term participants.", tag: "PLANNED" },
  { title: "Governance", body: "Planned voting rights as the protocol transitions toward a DAO.", tag: "FUTURE" },
  { title: "Ecosystem Services", body: "Access to planned applications and services built around XVPR.", tag: "PLANNED" },
  { title: "Developer Incentives", body: "Planned grants and rewards for builders on the ecosystem.", tag: "FUTURE" },
];

export const ECOSYSTEM = [
  { title: "Xenovia Prime Wallet", body: "Planned non-custodial wallet for holding and managing XVPR." },
  { title: "Xenovia Prime Explorer", body: "Planned explorer for XVPR transactions, treasury transparency and governance activity." },
  { title: "Governance Portal", body: "Planned proposal and voting platform for the community." },
  { title: "Developer Hub", body: "Planned documentation, APIs, SDKs and development resources." },
  { title: "Merchant Portal", body: "Planned tools for businesses to accept XVPR payments." },
];

export const STAKING_TIERS = [
  { period: "30 Days", mult: "1.00X" },
  { period: "90 Days", mult: "1.20X" },
  { period: "180 Days", mult: "1.50X" },
  { period: "365 Days", mult: "2.00X" },
];

export const BUYBACK_POINTS = [
  "No Transaction Tax",
  "Fixed Maximum Supply",
  "Potential Supply Reduction",
];

export const SECURITY = [
  { title: "Independent Audit", body: "Planned before deployment." },
  { title: "Fixed Supply Verification", body: "On-chain verifiable maximum supply." },
  { title: "Access Control", body: "Restricted privileged functions by design." },
  { title: "Transfer Security", body: "Hardened token transfer logic." },
  { title: "Burn Mechanism", body: "Transparent, community-approved burns." },
  { title: "Multi-Signature Treasury", body: "Treasury secured by multiple signers." },
  { title: "Hardware-Secured Keys", body: "Critical keys held on hardware devices." },
  { title: "Bug Bounty", body: "Planned program to reward responsible disclosure." },
];

export const GOVERNANCE = [
  { stage: "Stage I", title: "Foundation Governance", body: "The foundation stewards early development, security and deployment decisions." },
  { stage: "Stage II", title: "Community Participation", body: "The community is progressively invited into decision-making and proposals." },
  { stage: "Stage III", title: "DAO Governance", body: "On-chain governance where token holders direct the protocol.", tag: "FUTURE PHASE" },
];

export const ROADMAP = [
  {
    phase: "Phase I", title: "Foundation", period: "Year 1",
    items: ["Official whitepaper", "Xenovia Prime Foundation", "XVPR smart contract", "Independent security audits", "Official website", "Developer documentation", "Community channels"],
  },
  {
    phase: "Phase II", title: "Market Launch", period: "Year 1–2",
    items: ["Launch XVPR", "Initial liquidity", "DEX listings", "Exchange outreach", "Xenovia Prime Wallet", "Staking"],
  },
  {
    phase: "Phase III", title: "Ecosystem Growth", period: "Year 2–3",
    items: ["Governance portal", "Merchant payment integrations", "Developer SDK", "Ecosystem grants", "Community-built applications", "International awareness"],
  },
  {
    phase: "Phase IV", title: "Decentralization", period: "Year 3–4",
    items: ["DAO governance", "Treasury transition", "Ecosystem partnerships", "Interoperability", "Developer tooling"],
  },
  {
    phase: "Phase V", title: "Global Expansion", period: "Year 5+",
    items: ["Mature governance", "Enterprise adoption", "Merchant network", "Cross-chain integrations", "Continued ecosystem innovation"],
  },
];

export const FAQ = [
  { q: "What is Xenovia Prime?", a: "Xenovia Prime is a fixed-supply digital asset designed for a growing Web3 ecosystem, built around transparency, security, sustainable economics and community participation." },
  { q: "What is XVPR?", a: "XVPR is the token symbol of Xenovia Prime, a BEP-20 asset on BNB Smart Chain with a fixed maximum supply of 50,000,000,000,000 tokens." },
  { q: "Is Xenovia Prime currently launched?", a: "Xenovia Prime is currently in its presale / pre-launch stage. The public market launch is part of the project's roadmap." },
  { q: "What blockchain is XVPR built on?", a: "BNB Smart Chain using the BEP-20 standard." },
  { q: "What is the maximum supply?", a: "50,000,000,000,000 XVPR." },
  { q: "Can more XVPR be minted?", a: "The protocol is designed with permanently disabled additional minting after deployment." },
  { q: "What is XVPR designed for?", a: "Payments, merchant payments, staking, governance, ecosystem services and future applications. Several of these are planned or future features." },
  { q: "Is staking currently live?", a: "No. Staking is a planned ecosystem feature and is not currently live." },
  { q: "Is XVPR currently listed on exchanges?", a: "No exchange listing is claimed. Any listings would be announced officially through verified channels." },
  { q: "What is the presale price?", a: "The presale price is shown in the presale section and is currently [CONFIGURE]." },
];
